import styled from "styled-components"

/**
 * Table name representation
 */
export const TableHeader = styled.div`
	height: 35px;
	padding: 0 0.75em;

	> div {
		font-size: var(--default-font-size);
		line-height: var(--default-line-height);
		text-overflow: ellipsis;
		overflow: hidden;
		text-transform: uppercase;
	}
`
/**
 * Table
 */
export const TableLayout = styled.table`
	text-indent: initial;
`
/**
 * Table Header
 */
export const THead = styled.thead`
	color: #616266;
	vertical-align: middle;
	border-bottom: 1px solid #616266;
	background: #f2f2f2;
	border-radius: 10px 10px 0px 0px;
`
/**
 * Table Body
 */
export const TBody = styled.tbody`
	vertical-align: middle;
	border-color: inherit;
`
/**
 * Tabke Riw
 */
export const Tr = styled.tr`
	vertical-align: inherit;
	border-color: unset;
	border-radius: 0px;
	height: 50px;
`
/**
 * Header cell
 */
export const Td = styled.td`
	vertical-align: inherit;
	text-align: left;
	padding-left: 5px;
	font-size: 14px;

	:nth-child(1) {
		border-radius: 5px 0px 0px 5px !important;
	}
	:nth-last-child(1) {
		border-radius: 0px 5px 5px 0px !important;
	}
`

/**
 * Content cell
 */
export const Th = styled.th`
	vertical-align: inherit;
	font-weight: bold;
	text-align: -internal-center;
	text-align: left;
	padding: 4px;
	padding-left: 0.5em;
	padding-right: 0.5em;
	height: 50px;
	font-size: 16px;
	overflow: hidden;
	min-width: 100px;

	@media (max-width: 900px) {
		font-size: 14px;
	}

	@media (max-width: 600px) {
		font-size: 12px;
	}
	:nth-child(1) {
		border-radius: 10px 0px 0px 0px !important;
	}
	:nth-last-child(1) {
		border-radius: 0px 10px 0px 0px !important;
	}
`
